import { RESPONSIVE_GRID_TWO_TO_ONE_COLUMN_CLASS_NAME } from '../../constants/responsive-grid-layout';

export const MARKET_PAGE_GRID_CLASS_NAME = `${RESPONSIVE_GRID_TWO_TO_ONE_COLUMN_CLASS_NAME} gap-[20px]`;
